// extracted by mini-css-extract-plugin
module.exports = {"customSearch":"MegaMenu_customSearch__2z8SM","faCustom":"MegaMenu_faCustom__j7XPY","itemList":"MegaMenu_itemList__2wN4F"};